export const getStatus = (item) => {
  let status = "";

  if (item?.status?.includes("HOLD")) {
    status = "HOLD";
  } else if (item?.status?.includes("CONTRACTED")) {
    status = "CONTRACTED";
  } else if (item?.status === "RO-INVITE" && item?.tag === null) {
    status = "Belum Diundang HR";
  } else if (item?.status === "RO-INVITE" && item?.tag === "Invited") {
    status = "Diundang HR";
  } else if (item?.status === "RO-INVITE" && item?.tag === "Declined") {
    status = "Menolak Undangan HR";
  } else if (item?.status === "RO-INVITE" && item?.tag === "Reschedule") {
    status = "Req. Reschedule Interview HR";
  } else if (item?.status === "RO-INVITE" && item?.tag === "Accepted") {
    status = "Butuh Penilaian HR";
  } else if (item?.status === "RO-DISQUALIFIED" && item?.tag === "Declined") {
    status = "Tidak Lolos Interview HR";
  } else if (item?.status === "RO-INVITE" && item?.tag === "Absent") {
    status = "Tidak Hadir Interview HR";
  } else if (item?.status === "CLIENT-INVITE" && item?.tag === null) {
    status = "Belum Diundang User";
  } else if (item?.status === "CLIENT-INVITE" && item?.tag === "Declined") {
    status = "Menolak Undangan User";
  } else if (item?.status === "CLIENT-INVITE" && item?.tag === "Invited") {
    status = "Diundang User";
  } else if (item?.status === "CLIENT-INVITE" && item?.tag === "Accepted") {
    status = "Belum Kirim Rekomendasi";
  } else if (item?.status === "CLIENT-INVITE" && item?.tag === "Recommended") {
    status = "Dikirim Rekomendasi ke User";
  } else if (
    item?.status === "CLIENT-DISQUALIFIED" &&
    item?.tag === "Declined"
  ) {
    status = "Tidak Lolos Interview User";
  } else if (item?.status === "OFFER-INVITE" && item?.tag === null) {
    status = "Belum Dikirim Offering";
  } else if (item?.status === "OFFER-INVITE" && item?.tag === "Declined") {
    status = "Penawaran Offering Ditolak";
  } else if (item?.status === "OFFER-INVITE" && item?.tag === "Invited") {
    status = "Dikirim Offering";
  } else if (item?.status === "BS-REGISTERED" && item?.stage === "REGISTER") {
    status = "Menunggu Verifikasi Pertama";
  } else if (
    item?.status === "BS-REGISTERED" &&
    item?.tag === "Declined" &&
    item?.stage === "FIRST-VERIFICATION"
  ) {
    status = "Perbaikan Data Offering";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.stage === "GENERATE-CONTRACT" &&
    item?.tag !== "Declined"
  ) {
    status = "Belum Generate";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.tag === "Declined" &&
    item?.stage === "GENERATE-CONTRACT"
  ) {
    status = "Perbaikan Genetate Kontrak";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.stage === "APPROVE-CONTRACT"
  ) {
    return "Menunggu Approval BM";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.stage === "SIGN-CONTRACT" &&
    item?.tag === "Invited"
  ) {
    status = "TTD Kontrak";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.stage === "SIGN-CONTRACT" &&
    item?.tag === "Accepted"
  ) {
    status = "Menunggu Verifikasi Kedua";
  } else if (
    item?.status === "BS-PRE-CONTRACT" &&
    item?.tag === "Declined" &&
    item?.stage === "SECOND-VERIFICATION"
  ) {
    status = "Perbaikan TTD Kontrak";
  } else if (item?.status === "BS-CONTRACT" && item?.stage === "DONE") {
    status = "Gagal Inject";
  } else if (item?.status === "BS-CONTRACT" && item?.stage === "IOS-SUCCESS") {
    status = "IOS SUCCESS";
  } else if (item?.status === "BS-CANCELLED") {
    status = "CANCELLED";
  }

  return status;
};
